import { trigger, transition, style, animate, state } from '@angular/animations';


export const springEaseIn500ms = '550ms linear(0, 0.002 0.3%, 0.007 0.6%, 0.025 1.2%, 0.058 1.9%, 0.109 2.7%, 0.219 4.1%, 0.61 8.6%, 0.727 10.2%, 0.819 11.7%, 0.896 13.3%, 0.958 15%, 1.002 16.8%, 1.018 17.8%, 1.03 18.8%, 1.039 19.8%, 1.044 20.9%, 1.046 22%, 1.045 23.3%, 1.04 25.4%, 1.018 30.9%, 1.009 34%, 1.002 37.6%, 0.998 41.7%, 1 62.8%, 1)';
export const springEaseIn300ms = '300ms linear(0, 0.002 0.3%, 0.007 0.6%, 0.025 1.2%, 0.058 1.9%, 0.109 2.7%, 0.219 4.1%, 0.61 8.6%, 0.727 10.2%, 0.819 11.7%, 0.896 13.3%, 0.958 15%, 1.002 16.8%, 1.018 17.8%, 1.03 18.8%, 1.039 19.8%, 1.044 20.9%, 1.046 22%, 1.045 23.3%, 1.04 25.4%, 1.018 30.9%, 1.009 34%, 1.002 37.6%, 0.998 41.7%, 1 62.8%, 1)';
export const springEaseIn0ms = '0ms linear(0, 0.002 0.3%, 0.007 0.6%, 0.025 1.2%, 0.058 1.9%, 0.109 2.7%, 0.219 4.1%, 0.61 8.6%, 0.727 10.2%, 0.819 11.7%, 0.896 13.3%, 0.958 15%, 1.002 16.8%, 1.018 17.8%, 1.03 18.8%, 1.039 19.8%, 1.044 20.9%, 1.046 22%, 1.045 23.3%, 1.04 25.4%, 1.018 30.9%, 1.009 34%, 1.002 37.6%, 0.998 41.7%, 1 62.8%, 1)';



export const fadeInOutWithBlur =
    trigger('fadeInOutWithBlur', [
        transition(':enter', [
            style({ opacity: 0, filter: 'blur(40px)' }),
            animate(springEaseIn500ms, style({ opacity: 1, filter: 'blur(0px)' })),
        ]),
        transition(':leave', [
            style({ opacity: 1, filter: 'blur(0px)' }),
            animate(springEaseIn0ms, style({ opacity: 0, filter: 'blur(40px)' })),
        ])
    ]);


export const fadeInOut =
    trigger('fadeInOut', [
        transition(':enter', [
            style({ opacity: 0 }),
            animate('300ms cubic-bezier(0.25, 0.1, 0.25, 1)', style({ opacity: 1 })),
        ]),
        transition(':leave', [
            style({ opacity: 1, filter: 'blur(0px)' }),
            animate('300ms cubic-bezier(0.25, 0.1, 0.25, 1)', style({ opacity: 0 })),
        ])
    ])

export const zoomInOut =
    trigger('zoomInOut', [
        transition(':enter', [
            style({ opacity: 0, transform: 'scale(200%)', width:'100%' }),
            animate(springEaseIn500ms, style({ transform: 'scale(100%)', opacity: 1, width:'100%' })),
        ]),
        transition(':leave', [
            style({ opacity: 1, transform: 'scale(100%)', width:'100%' }),
            animate(springEaseIn500ms, style({ transform: 'scale(200%)', opacity: 0, width:'100%' })),
        ])
    ])

export const zoomInOutWithBlur =
    trigger('zoomInOutWithBlur', [
        transition(':enter', [
            style({ opacity: 0, transform: 'scale(200%)', filter: 'blur(40px)' }),
            animate(springEaseIn500ms, style({ transform: 'scale(100%)', opacity: 1, filter: 'blur(0px)' })),
        ]),
        transition(':leave', [
            style({ opacity: 1, transform: 'scale(100%)', filter: 'blur(0px)' }),
            animate(springEaseIn0ms, style({ transform: 'scale(200%)', opacity: 0, filter: 'blur(40px)' })),
        ])
    ])
    
export const zoomInOutWithBlurState =
    trigger('zoomInOutWithBlurState', [
        state('false', style({ transform: 'scale(100%)', opacity: 1, filter: 'blur(0px)' })),
        state('true', style({  transform: 'scale(200%)', opacity: 0, filter: 'blur(40px)' })),
        transition('false => true', animate(springEaseIn500ms)),
        transition('true => false', animate(springEaseIn500ms))
    ])

export const slideDownUp =
    trigger('slideDownUp', [
        transition(':enter', [
            style({ overflow: 'hidden', height: '0', opacity: 0, 'padding': "0", 'margin': "0" }),
            animate(springEaseIn300ms, style({ overflow: 'hidden', height: '*', opacity: 1, 'padding': "*", 'margin': "*" })),
        ]),
        transition(':leave', [
            style({ overflow: 'hidden', height: '*', opacity: 1, 'padding': "*", 'margin': "*" }),
            animate(springEaseIn300ms, style({ overflow: 'hidden', height: '0', 'padding-top': 0, 'padding-bottom': 0, opacity: 0, 'padding': "0", 'margin': "0" })),
        ]),
    ]);


export const slideDownUpFastLeave =
    trigger('slideDownUpFastLeave', [
        transition(':enter', [
            style({ overflow: 'hidden', height: '0', opacity: 0, 'padding': "0", 'margin': "0" }),
            animate(springEaseIn300ms, style({ overflow: 'hidden', height: '*', opacity: 1, 'padding': "*", 'margin': "*" })),
        ]),
        transition(':leave', [
            style({ overflow: 'hidden', height: '*', opacity: 1, 'padding': "*", 'margin': "*" }),
            animate('0ms', style({ overflow: 'hidden', height: '0', 'padding-top': 0, 'padding-bottom': 0, opacity: 0, 'padding': "0", 'margin': "0" })),
        ]),
    ]);

export const slideDownUpWithBlur =
    trigger('slideDownUpWithBlur', [
        transition(':enter', [
          style({ 'filter': ' blur(40px)', 'height': "0", 'padding': 0 ,  'margin': 0,'opacity': 0 }),
          animate(springEaseIn500ms, style({ 'filter': ' blur(0)', 'height': "*",  'padding': "*",  'margin': "*",'opacity': 1  })),
        ]),
        transition(':leave', [
          style({ 'opacity': 1, 'filter': ' blur(0)', 'height': "*",  'padding': "*",  'margin': "*" }),
          animate(springEaseIn500ms, style({ 'opacity': 0, 'filter': ' blur(40px)', 'height': "0", 'padding': 0, 'margin': "0"  })),
        ])
      ]);

export const slideRightLeft =
    trigger('slideRightLeft', [
        transition(':enter', [
            style({ overflow: 'hidden', width: '0', opacity: 0, transform: 'translateX(100%)' }),
            animate('300ms cubic-bezier(0.25, 0.1, 0.25, 1)',
                style({ overflow: 'hidden', width: '*', opacity: 1, transform: 'translateX(0)' }))
        ]),
        transition(':leave', [
            style({ overflow: 'hidden', width: '*', opacity: 1, transform: 'translateX(0)' }),
            animate('330ms cubic-bezier(0.25, 0.1, 0.25, 1)',
                style({ overflow: 'hidden', width: '0', opacity: 0, transform: 'translateX(100%)' }))
        ])
    ]);

export const slideLeftRight =
    trigger('slideLeftRight', [
        transition(':enter', [
            style({ overflow: 'hidden', width: '0', opacity: 0, transform: 'translateX(-100%)' }),
            animate(springEaseIn500ms,
                style({ overflow: 'hidden', width: '*', opacity: 1, transform: 'translateX(0)' }))
        ]),
        transition(':leave', [
            style({ overflow: 'hidden', width: '*', opacity: 1, transform: 'translateX(0)' }),
            animate(springEaseIn500ms,
                style({ overflow: 'hidden', width: '0', opacity: 0, transform: 'translateX(-100%)' }))
        ])
    ]);

export const opacity =
    trigger('opacity', [
        transition(':enter', [
            style({ opacity: 0 }),
            animate('300ms cubic-bezier(0.25, 0.1, 0.25, 1)', style({ opacity: 1 })),
        ]),
        transition(':leave', [
            style({ opacity: 1 }),
            animate('330ms cubic-bezier(0.25, 0.1, 0.25, 1)', style({ opacity: 0 })),
        ]),
    ]);